import React, { useState, useEffect } from "react";
import ViewPage from "../../../controls/ViewPage";
import Icon from "../../../../assets/icons/Icon";
import ProductOverview from "./ProductOverview";
import ProductSalesTransaction from "./ProductSalesTransaction";
import ProductInventorytransaction from "./ProductInventorytransaction";
import ProductInstock from "./ProductInstock";
import ProductApiLogs from "./ProductApiLogs";
import ProductAuditTrial from "./ProductAuditTrial";
import Tab from "../../../controls/Tab";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteProductDataApi } from "../../../../api/ProductApi";
import ConfirmBox from "../../../controls/ConfirmBox";
import Loading from "../../../controls/Loading";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectRegistration } from "../../../../redux/slices/userSlice";

const Viewproduct = ({ productData,isAllowUpdate,isAllowDelete, handleRemoveBtnClick,handleOnDelete }) => {
      const selectedStore= useSelector((state) => state.store.store);
      console.log("selectedStore",selectedStore);
  const [activeTab, setActiveTab] = useState("overview");
  const registration = useSelector(selectRegistration);
  const isSmartStore = registration?.EnablePincodeSmartStore || false;
  const isProductLock=productData?.IsProductLocked || false;
  console.log("isProductLoceked",isProductLock,"issmartstore",isSmartStore);
  // const [productData, setProductData] = useState({});
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const isPincode = false;
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (location.state?.row) {
  //     setProductData(location.state.row);
  //     console.log("all product data",productData);
  //   }
  // }, [location.state]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  const handleEditBtnClick = () => {
    navigate(`/catalogue/product/Addproduct/${productData?.key}`);
  };


  const handleDeleteBtnClick = () => {
    setOpenDeleteConfirm(true)
  };
  const handleConfirmDelete = async () => {
    setOpenDeleteConfirm(false);
    setLoading(true);
    try {
     const response= await deleteProductDataApi(productData?.key);
     if(response.code=="0"){
      toast.success("Product deleted successfully");
       setTimeout(() => {
        
      handleOnDelete();
     setLoading(false);
      
  }, 3000); // 5000 ms = 5 seconds
     }
     else{
      toast.error(response?.message || "Failed to delete product");
     }
      
   
    } catch (error) {
      setLoading(false);
      console.error("Error deleting product:", error);
      toast.error("Failed to delete product");
    }
  };




  const tabs = [
    { name: "overview", label: "Overview" },
    ...(productData?.ProductTypeID === 1 || productData?.ProductTypeID === 2 ? [{ name: "instock", label: "In Stock" }] : []),
    { name: "sales", label: "Sales Transactions" },
    ...(productData?.ProductTypeID === 1 || productData?.ProductTypeID === 2 ? [{ name: "inventory", label: "Inventory Transactions" }] : []),
    { name: "audit", label: "Audit Trail" },
  ];

  useEffect(() => {
    setActiveTab("overview");
  }, [productData])

  return (
 <ViewPage
  name={productData.Name || "Product Name"}
   iconButtons={[
            // Print Barcode button (always visible when data?.Status === "Completed")
        
            
          
          ...(productData.IsDeleted && isAllowUpdate
    ? []
    : [
        {
          label: "Edit",
          onClick: handleEditBtnClick,
          icon: <Icon type="edit" />,
          tooltipWidth: "100px",
        },
      ]),

  // Conditionally add "Delete" button
  ...(!productData.IsDeleted && isAllowDelete
    ? [
        {
          label: "Delete",
          onClick: handleDeleteBtnClick,
          icon: <Icon type="delete" />,
          tooltipWidth: "100px",
        },
      ]
    : []),

          
          ]}
  handleRemoveBtnClick={handleRemoveBtnClick}
  tabs={
    <>
      <Tab tabs={tabs} isNowrap={true} activeTab={activeTab} onTabChange={handleTabChange} />
    </>
  }
>
      {/* Main Content */}
      {activeTab === "overview" && (
        <div className="flex-grow ">
          <ProductOverview productData={productData} isSmartStore={isSmartStore}/>
        </div>
      )}
      {activeTab === "instock" && (
        <div className="flex-grow ">
          <ProductInstock productData={productData} />
        </div>
      )}
      {activeTab === "sales" && (
        <ProductSalesTransaction productData={{ key: productData.key }} />

      )}
      {activeTab === "inventory" && (

        <ProductInventorytransaction productData={{ key: productData.key }} />

      )}
      {activeTab === "apilogs" && (
        <div className="flex-grow ">
          <ProductApiLogs productData={{ key: productData.key }} />
        </div>
      )}
      {activeTab === "audit" && (
        <div className="flex-grow ">
          <ProductAuditTrial productData={{ key: productData.key }} />
        </div>
      )}
      {loading && <Loading />}
      {openDeleteConfirm && (
        <ConfirmBox
          title={
            <>
              Are you sure you want to delete{" "}
              <span className="text-red-500">{productData?.Name}</span>?
            </>
          }
          text="This action cannot be undone."
          onConfirm={handleConfirmDelete}
          onCancel={() => { setOpenDeleteConfirm(false) }}
        />

      )}
    </ViewPage>
  );
};

export default Viewproduct;